import React from "react";
import moment from "moment";
import "./DateDetailModal.css";

const DateDetailModal = ({ isOpen, onClose, selectedDate, events }) => {
  if (!isOpen) return null;

  const formattedDate = selectedDate 
    ? moment(selectedDate).format("dddd, MMMM D, YYYY")
    : "";

  const getEventColor = (type) => {
    const colors = {
      session: "#D8BFD8",
      celebration: "#4169E1",
      holiday: "#FFFF00",
      competition: "#FFC0CB",
      exam: "#90EE90",
      ptm: "#DDA0DD",
    };
    return colors[type?.toLowerCase()] || "#e3f2fd";
  };

  return (
    <>
      {/* Backdrop */}
      <div className="date-modal-backdrop" onClick={onClose}></div>

      {/* Bottom Sheet Modal */}
      <div className={`date-modal-sheet ${isOpen ? "slide-up" : ""}`}>
        {/* Handle Bar */}
        <div className="modal-handle-bar"></div>

        {/* Header */}
        <div className="modal-header-section">
          <h3 className="modal-date-title">{formattedDate}</h3>
          <button className="modal-close-btn" onClick={onClose}>
            <i className="fa fa-times"></i>
          </button>
        </div>

        {/* Events List */}
        <div className="modal-events-container">
          {events && events.length > 0 ? (
            events.map((event, index) => (
              <div
                key={index}
                className="modal-event-card"
                style={{ borderLeftColor: getEventColor(event.type) }}
              >
                <div className="event-color-indicator" 
                     style={{ backgroundColor: getEventColor(event.type) }}>
                </div>
                <div className="event-details">
                  <h4 className="event-name">{event.name || event.details}</h4>
                  <p className="event-type">
                    <i className="fa fa-tag"></i> {event.type || "Event"}
                  </p>
                  {event.start_date && event.end_date && (
                    <p className="event-duration">
                      <i className="fa fa-clock-o"></i>
                      {moment(event.start_date, "DD-MM-YYYY").format("MMM D")} - 
                      {moment(event.end_date, "DD-MM-YYYY").format("MMM D")}
                    </p>
                  )}
                </div>
              </div>
            ))
          ) : (
            <div className="no-events-message">
              <i className="fa fa-calendar-o"></i>
              <p>No events scheduled for this day</p>
            </div>
          )}
        </div>

        {/* Footer Actions (Optional) */}
        <div className="modal-footer-actions">
          <button className="modal-action-btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </>
  );
};

export default DateDetailModal;